import switchValuation from '../Services/switchValuation';

export default (id) => async (dispatch) => {
  dispatch(switchValuation(id))
}